import { render } from "./ArtInvestApproachComponent.vue?vue&type=template&id=0ec8335e&scoped=true"
import script from "./ArtInvestApproachComponent.vue?vue&type=script&lang=js"
export * from "./ArtInvestApproachComponent.vue?vue&type=script&lang=js"

import "./ArtInvestApproachComponent.vue?vue&type=style&index=0&id=0ec8335e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ec8335e"]])

export default __exports__